import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const QuantumLeapAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<20; i++){
    if(Math.random() > 0.6) {
      const ang = Math.random() * Math.PI * 2;
      const dst = e.maxRadius + (Math.random() - 0.5) * 100 * progress;
      const r = getRadiusAtAngle(ang, e, dst);
      ctx.fillRect(e.pos.x + Math.cos(ang) * r, e.pos.y + Math.sin(ang) * r, 8, 8);
    }
  }
};

registerBlastAnimation('QUANTUM_LEAP', QuantumLeapAnimation);
